import React, { useEffect, useState } from "react";
import Card from "../../../../components/common/Card";
import { CardHeader, CardTitle } from "react-bootstrap";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Button,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import Modal from "react-bootstrap/Modal";
import { AssessmentCreditPackPriceService } from
  "../../../../service/manage/exam_subscription/assessCreditPackagePrice.service";

function CreditBuyLimitManage() {
  const [limitCount, setLimitCount] = useState(null);
  const [statusId, setStatusId] = useState(1);
  const [id, setId] = useState(null);

  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res =
        await AssessmentCreditPackPriceService.getLimitOfBuyCreditPackages();
      setLimitCount(res.data.limit_count);
      setStatusId(res.data.status_id);
      setId(res.data.id);
    } catch (error) {
      console.error("Error fetching credit buy limit:", error);
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      await AssessmentCreditPackPriceService.updateLimitOfBuyCreditPackages({  
        id: id, 
        limit_count: limitCount,
        status_id: statusId,
      });

      setIsEditing(false);
    } catch (error) {
      console.error("Error saving credit buy limit:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle tag="h4">Credit Buy Limit Management</CardTitle>
        </CardHeader>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Limit Count</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            <TableRow>
              <TableCell>{limitCount}</TableCell>
              <TableCell>
                {statusId === 1 ? "Active" : "Inactive"}
              </TableCell>
              <TableCell align="center">
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => setIsEditing(true)}
                >
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>

      {/* EDIT MODAL */}
      <Modal
        show={isEditing}
        size="md"
        centered
        onHide={() => setIsEditing(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Credit Buy Limit</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* LIMIT COUNT */}
          <div className="mb-3">
            <label className="form-label">Limit Count</label>
            <TextField
              type="text"
              fullWidth
              size="small"
              placeholder="Enter count.."
              value={limitCount}
              onChange={(e) => setLimitCount(Number(e.target.value))}
            />
          </div>

          {/* STATUS */}
          <div className="mb-3">
            <label className="form-label">Status</label>
            <Select
              fullWidth
              size="small"
              value={statusId}
              onChange={(e) => setStatusId(e.target.value)}
            >
              <MenuItem value={1}>Active</MenuItem>
              <MenuItem value={0}>Inactive</MenuItem>
            </Select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="outlined"
            onClick={() => setIsEditing(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CreditBuyLimitManage;
